import(/* webpackMode: "eager" */ "/home/runner/work/AlUmmahNow/AlUmmahNow/apps/web/src/app/[locale]/not-found.tsx");
